import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { useForm } from "react-hook-form";
import ControllerTextInputTwoRow from "components/GenericComponent/ControllerTextInputTwoRow";
function CreateGuid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return _p8() + _p8(true) + _p8(true) + _p8();
}

const ThemMoiLoaiTaiSan = (props) => {
  let currentForm = useForm();
  const [ListThuocTinh, setListThuocTinh] = useState([]);
  const [isReload, setisReload] = useState(false);
  const { register, handleSubmit, errors, control } = currentForm; // initialize the hook

  let { onHide, show, postLoaiTaiSan } = props;

  const onChangeTenThuocTinh = (index) => (evt) => {
    ListThuocTinh[index].TenThuocTinh = evt.target.value;
    setListThuocTinh(ListThuocTinh);
    setisReload(!isReload);
  };
  const themThuocTinh = () => {
    ListThuocTinh.push({ MaThuocTinh: CreateGuid(), TenThuocTinh: "" });
    setListThuocTinh(ListThuocTinh);
    setisReload(!isReload);
  };

  const onSubmit = (dataLoaiTaiSan) => {
    postLoaiTaiSan(dataLoaiTaiSan);
  };
  return (
    <Modal
      show={show}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="fas fa-plus"></i>
          </span>
          Thêm mới loại tài sản
        </h4>
        <button type="button" className="close-popup-new" onClick={onHide}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="">
          <div class="form tat-toan form-horizontal form-edit">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse196"
                  class="card-header border-info"
                  href="#collapse196"
                  aria-expanded="true"
                  aria-controls="collapse196"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Thông tin chung</h3>
                  </a>
                </div>
                <div
                  id="collapse196"
                  aria-labelledby="headingCollapse96"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content mt-1">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Lĩnh vực"
                            value="Cầm đồ + Nhận vay +Trả góp"
                            disabled="disabled"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <ControllerTextInputTwoRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            inputWrapClass=""
                            wrapperClass="form-group"
                            labelText="Mã loại tài sản"
                            placeholder="Ví dụ: XM, DT"
                            starRed="(*)"
                            inputProps={{
                              rules: {
                                required: "Hãy nhập mã loại tài sản",
                              },
                              name: "MaHangHoa",
                              value: "",
                              control: control,
                            }}
                            error={errors.MaHangHoa && errors.MaHangHoa}
                          ></ControllerTextInputTwoRow>
                        </div>

                        <div class="col-md-3">
                          <ControllerTextInputTwoRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            inputWrapClass=""
                            wrapperClass="form-group"
                            labelText="Tên loại tài sản"
                            placeholder="Xe máy"
                            starRed="(*)"
                            inputProps={{
                              rules: {
                                required: "Hãy nhập tên loại tài sản",
                              },
                              name: "TenHangHoa",
                              value: "",
                              control: control,
                            }}
                            error={errors.TenHangHoa && errors.TenHangHoa}
                          ></ControllerTextInputTwoRow>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label for="projectinput1">Trạng thái</label>
                            <select
                              class="selectBox form-control input-sm"
                              ref={register}
                              name="TrangThaiHangHoa"
                            >
                              <option value="0">Bình thường</option>
                              <option value="1">Khóa</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse1961"
                  class="card-header border-info mt-1"
                  href="#collapse1961"
                  aria-expanded="true"
                  aria-controls="collapse1961"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Cấu hình thuộc tính hàng hóa</h3>
                  </a>
                </div>
                <div
                  id="collapse1961"
                  aria-labelledby="headingCollapse961"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content mt-1">
                    <div class="card-body">
                      <div class="row">
                        {ListThuocTinh &&
                          ListThuocTinh.map((item, index) => (
                            <div class="col-md-3">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText={"Thuộc tính " + (index + 1)}
                                placeholder="VD: Biển số xe"
                                inputProps={{
                                  name:
                                    "ListThuocTinhTaiSan[" +
                                    index +
                                    "].TenThuocTinh",
                                  ref: register,
                                  value: item.TenThuocTinh,
                                  onChange: onChangeTenThuocTinh(index),
                                }}
                              ></TextInputOnRow>
                              <input
                                type="text"
                                className="hidden"
                                ref={register}
                                name={
                                  "ListThuocTinhTaiSan[" +
                                  index +
                                  "].MaThuocTinh"
                                }
                                value={item.MaThuocTinh}
                              ></input>
                            </div>
                          ))}
                        <div class="col-md-3">
                          <div class="text-left t-button-1">
                            <button
                              type="button"
                              class="btn btn-info"
                              onClick={themThuocTinh}
                            >
                              <i class="la la-plus"></i> Thêm thuộc tính
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" className="btn btn-new-main btn-checknew">
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Thêm mới
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
export default ThemMoiLoaiTaiSan;
